import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHaskellComponent } from './simple-icons-haskell.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHaskellComponent ],
    exports:      [ SimpleIconsHaskellComponent ],
    bootstrap:    []
})
export class SimpleIconsHaskellModule {}
